<!-- MODAL detalleHistoricoDocumento -->
<div mdbModal #detalleHistoricoDocumento="mdb-modal" style="overflow-y: auto;" class="modal fade" id="basicExample"
    tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
    [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <form>
        <div class="modal-dialog modal-fluid" style="width: 80%;" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title w-100 text-left" id="myModalLabel">
                        Detalle Histórico Documento
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        (click)="detalleHistoricoDocumento.hide()">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">

                    <ng-container *ngIf="loading">
                        <div class="card-body" style="justify-content: center; text-align: center;">
                            <mdb-spinner spinnerColor="blue"></mdb-spinner>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="cabecera">
                        <div class="card-body justify-content-between" style="padding-top: 0 !important;">
                            <div class="row filtros-body">
                                <div class="col dato">
                                    <Strong class="title">Documento</Strong>
                                    <span class="value">{{cabecera.folio | numerico}}</span>
                                </div>
                                <div class="col dato">
                                    <Strong class="title">Fecha</Strong>
                                    <span class="value">{{cabecera.fecha_emision | fecha}}</span>
                                </div>
                            </div>
                            <div class="row filtros-body">
                                <div class="col dato">
                                    <Strong class="title">Emisor</Strong>
                                    <span class="value">{{cabecera.rut_emisorFormateado | rut}}<span
                                            class="mr-15"></span>{{cabecera.nombre_emisor}}</span>
                                </div>
                                <div class="col dato">
                                    <Strong class="title">Sucursal</Strong>
                                    <span class="value">{{cabecera.direccion_nombre}}</span>
                                </div>
                            </div>
                            <div class="row filtros-body">
                                <div class="col dato">
                                    <Strong class="title">Receptor</Strong>
                                    <span class="value">{{cabecera.rut_receptorFormateado | rut}}
                                        <span class="mr-15"></span>{{cabecera.nombre_receptor}}</span>
                                </div>
                            </div>
                            <div class="row filtros-body">
                                <div class="col dato">
                                    <Strong class="title">Monto</Strong>
                                    <span class="value">$ {{cabecera.monto_total | numerico}}</span>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="listaMovimientos">
                        <div class="table-responsive" *ngIf="listaMovimientos">
                            <table class="table table-striped table-hover table-sm align-middle">
                                <thead class="grey lighten-2">
                                    <tr>
                                        <th scope="col" style="width: 7rem; max-width: 9rem;">Fecha</th>
                                        <th scope="col" style="width: 5rem; max-width: 7rem;">Hora</th>
                                        <th scope="col">Evento</th>
                                        <th scope="col">Glosa Resultado</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- <tr *ngIf="loading">
                                        <td colspan="100%" style="text-align: center">
                                            <mdb-spinner spinnerColor="blue"></mdb-spinner>
                                        </td>
                                    </tr>
                                    <tr *ngIf="!loading && listaMovimientos?.length === 0">
                                        <td colspan="100%" style="text-align: center">
                                            No se encontró información
                                        </td>
                                    </tr> -->
                                    <tr *ngIf="listaMovimientos?.length === 0">
                                        <td colspan="100%" style="text-align: center">
                                            No se encontró información
                                        </td>
                                    </tr>
                                    <tr *ngFor="let doc of listaMovimientos">
                                        <td>{{doc.fecha_evento | fecha}}</td>
                                        <td>{{doc.fecha_evento | date:"HH:mm"}}</td>
                                        <td>{{doc.evento_nombre}}</td>
                                        <td>{{doc.observacion}}</td>
                                    </tr>
                                </tbody>
                                <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
                                    *ngIf="listaMovimientos?.length > 0"></app-pagination>
                            </table>
                        </div>
                    </ng-container>


                </div>

                <div class="modal-footer justify-content-between">
                    <button type="submit" class="btn btn-default waves-light" mdbWavesEffect
                        (click)="detalleHistoricoDocumento.hide()">
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>

<app-modal-confirm>
</app-modal-confirm>